<template>
  <div class="ibox form-page animated fadeInRightBig">
    <div class="ibox-title form-page__header">
      <div class="form-page__title-wrap">
        <h5 class="form-page__title">
          <i class="fa fa-user form-page__title-icon"></i>
          Meu perfil
        </h5>
        <p class="form-page__subtitle">Atualize sua foto de perfil</p>
      </div>
    </div>
    <div class="ibox-content form-page__body">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="form-group">
            <div class="circular--landscape" style="margin: 0 auto">
              <img :src="user.picture" alt="Sem Foto" />
            </div>
          </div>
          <div class="profile_user">
            <h3 class="user_name_max">{{ user.name }}</h3>
            <p>{{ user.email }}</p>
          </div>
        </div>

        <div class="col-md-6 col-md-offset-3 col-sm-12">
          <div class="form-group form-page__field">
            <label class="form-page__label" for="profile-photo">Nova foto</label>
            <input
              type="file"
              name="photo"
              id="profile-photo"
              class="form-control"
              accept="image/*"
            />
          </div>
          <div class="form-page__footer">
            <div class="form-page__actions">
              <button class="btn btn-add" @click="save" :disabled="saving">
                <i :class="saving ? 'fa fa-spinner fa-spin' : 'fa fa-save'"></i>
                {{ saving ? 'Salvando...' : 'Salvar' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      saving: false,
      user: {
        id: 0,
        name: "",
        email: "",
        picture: ""
      }
    };
  },
  methods: {
    save() {
      const self = this;
      const api = self.$store.getters.api + "users/image/update/" + self.user.id;
      const data = new FormData();
      const fileInput = document.getElementById("profile-photo");

      data.append("id", self.user.id);
      data.append("photo", fileInput.files[0] ? fileInput.files[0] : "");

      self.saving = true;
      $("#page_loader").show();

      self.$http
        .post(api, data)
        .then(() => {
          self.$message("Sucesso", "Foto atualizada com sucesso", "success");
          self.$store.commit("profileUpdate");
        })
        .catch(error => {
          const errors =
            (error.response && error.response.data) || "Erro ao salvar";
          self.$message(null, errors, "error");
        })
        .finally(() => {
          self.saving = false;
          $("#page_loader").hide();
        });
    }
  },
  mounted() {
    this.user = this.$store.state.user;
  }
};</script>



// WEBPACK FOOTER //
// src/components/Auth/Profile.vue